/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import {
    Card,
    Grid,
    Box,
    Typography,
    TextField,
    useTheme,
    useMediaQuery,
    PropTypes as MuIPropTypes,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {Formik, Field} from "formik";
import {colorError} from "../../../Constants/theme";
import {
    getAddress,
} from "../../../redux/userProfile/userProfile.actions";
import {useAppDispatch} from "../../../redux/store";
import DateFnsUtils from "@date-io/date-fns";
import {DatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import {IParentProfile} from "../../../interfaces";

interface Props {
    profile: object;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

declare global {
    interface String {
      toProperCase(): string;
    }
  }

const useStyle = makeStyles(() => ({
    wrapper: {
        padding: "1.5em"
    },
    formItem: {
        marginBottom: "1em",
    },
    inputGroup: {
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    applyBtn: {
        height: 45
    },
    input: {
        padding: "0.8rem 1rem"
    },
    formError: {
        color: colorError,
        fontSize: "12px",
        marginLeft: "14px",
    },
}));
let initialValues: IParentProfile = {
    firstName: "",
    lastName: "",
    findUs: "",
    phone: "",
    birthday: "",
    address: "",
    city: "",
    state: "",
    zip: "",
    country: "",
};
const PetParentProfile = ({profile, setOpen, isOpen}) => {
    const dispatch = useAppDispatch();
    const classes = useStyle();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
    const textAlignmentAdaptive: MuIPropTypes.Alignment = isMobile ? "center" : "left";
    const [formikValues, setFormikValues] = useState(initialValues);
    const [address, setAddress] = useState(null);

    useEffect(() => {
        if(isOpen) {
            dispatch(getAddress(profile.userId))
                .then((address) => {
                    setAddress(address);
                });
        }
    }, [isOpen]);

    return (
        <>
            <Formik initialValues={formikValues} onSubmit={() => {}}>
                <Card variant="outlined">
                    {/* Desiding if we want to show form or loader */}
                    {
                        <Grid container className={classes.wrapper}>
                            <Grid item container justify="space-between" alignItems="center">
                                <Grid container alignItems="center" item xs={12}>
                                    <Box marginBottom="10px">
                                        <Typography variant="h4">Client Profile</Typography>
                                    </Box>
                                </Grid>
                                <Grid item container alignItems="center" className={classes.formItem}>
                                    <Grid item xs={12} sm={6}>
                                        <Box marginBottom="10px">
                                            <Typography
                                                variant="h5"
                                                align={textAlignmentAdaptive}
                                            >
                                                First Name
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Field
                                            component={TextField}
                                            variant="outlined"
                                            fullWidth
                                            name="firstName"
                                            type="text"
                                            id="firstName"
                                            aria-labelledby="first Name"
                                            disabled
                                            onChange={() => {}}
                                            value={profile?.firstName}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid item container alignItems="center" className={classes.formItem}>
                                    <Grid item xs={12} sm={6}>
                                        <Box marginBottom="10px">
                                            <Typography variant="h5" align={textAlignmentAdaptive}>Last
                                                Name</Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Field
                                            component={TextField}
                                            variant="outlined"
                                            fullWidth
                                            name="lastName"
                                            id="lastName"
                                            aria-labelledby="Last Name"
                                            type="text"
                                            disabled
                                            onChange={() => {}}
                                            value={profile?.lastName}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container justify="space-between" alignItems="center"
                                className={classes.formItem}>
                                <Grid item xs={12} sm={6}>
                                    <Box marginBottom="10px">
                                        <Typography variant="h5"
                                            align={textAlignmentAdaptive}>Phone</Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Field
                                        component={TextField}
                                        variant="outlined"
                                        fullWidth
                                        autoComplete="tel-national"
                                        id="phone"
                                        aria-labelledby="phone"
                                        name="phone"
                                        type="tel"
                                        disabled
                                        onChange={() => {}}
                                        value={profile?.phoneNumber}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container justify="space-between" alignItems="center"
                                className={classes.formItem}>
                                <Grid item xs={12} sm={6}>
                                    <Box marginBottom="10px">
                                        <Typography variant="h5"
                                            align={textAlignmentAdaptive}>Birthday</Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <DatePicker
                                            name="birthday"
                                            disableFuture={true}
                                            inputVariant="outlined"
                                            fullWidth
                                            label="Your birthday"
                                            id="birthday"
                                            aria-labelledby="your birthday"
                                            format="MMM dd, yyyy"
                                            orientation="landscape"
                                            openTo="date"
                                            onChange={() => {}}
                                            disabled
                                            value={profile?.birthday || null}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                            </Grid>
                            <Grid container justify="space-between" alignItems="center"
                                className={classes.formItem}>
                                <Grid item xs={12} sm={6}>
                                    <Box marginBottom="10px">
                                        <Typography
                                            variant="h5"
                                            align={textAlignmentAdaptive}
                                        >
                                            Address
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Field
                                        component={TextField}
                                        name="address"
                                        id="address"
                                        aria-labelledby="address"
                                        variant="outlined"
                                        fullWidth
                                        multiline
                                        disabled
                                        autoComplete="shipping street-address"
                                        color="secondary"
                                        value={address?.firstLine}
                                        inputProps={{
                                            autoComplete: "shipping street-address",
                                        }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container justify="space-between" alignItems="center"
                                className={classes.formItem}>
                                <Grid item xs={12} sm={6}>
                                    <Box marginBottom="10px">
                                        <Typography
                                            variant="h5"
                                            align={textAlignmentAdaptive}
                                        >
                                            City
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Field
                                        component={TextField}
                                        fullWidth
                                        type="text"
                                        autoComplete="shipping address-level2"
                                        name="city"
                                        id="city"
                                        aria-labelledby="city"
                                        variant="outlined"
                                        disabled
                                        color="secondary"
                                        value={address?.city}
                                        inputProps={{
                                            autoComplete: "shipping address-level2",
                                        }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container justify="space-between" alignItems="center"
                                className={classes.formItem}>
                                <Grid item xs={12} sm={6}>
                                    <Box marginBottom="10px">
                                        <Typography
                                            variant="h5"
                                            align={textAlignmentAdaptive}
                                        >
                                            State / Location
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Field
                                        component={TextField}
                                        name="state"
                                        id="state"
                                        aria-labelledby="state"
                                        variant="outlined"
                                        color="secondary"
                                        fullWidth
                                        type="text"
                                        disabled
                                        autoComplete="shipping address-level1"
                                        value={address?.state}
                                        handleCustomChange={(value) => {}}
                                        placeholder="State"
                                        inputProps={{
                                            autoComplete: "shipping address-level1",
                                        }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container justify="space-between" alignItems="center"
                                className={classes.formItem}>
                                <Grid item xs={12} sm={6}>
                                    <Box marginBottom="10px">
                                        <Typography
                                            variant="h5"
                                            align={textAlignmentAdaptive}
                                        >
                                            Zip Code
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Field
                                        component={TextField}
                                        fullWidth
                                        type="text"
                                        autoComplete="shipping postal-code"
                                        disabled
                                        name="zip"
                                        id="zipcode"
                                        aria-labelledby="zipcode"
                                        variant="outlined"
                                        color="secondary"
                                        value={address?.zipCode}
                                        inputProps={{
                                            autoComplete: "shipping postal-code",
                                        }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container justify="space-between" alignItems="center"
                                className={classes.formItem}>
                                <Grid item xs={12} sm={6}>
                                    <Box marginBottom="10px">
                                        <Typography
                                            variant="h5"
                                            align={textAlignmentAdaptive}
                                        >
                                            Country
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Field
                                        component={TextField}
                                        fullWidth
                                        type="text"
                                        autoComplete="shipping country"
                                        name="country"
                                        id="country"
                                        aria-labelledby="country"
                                        variant="outlined"
                                        color="secondary"
                                        disabled
                                        value={address?.country}
                                        inputProps={{
                                            autoComplete: "shipping country",
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    }
                </Card>
            </Formik>
        </>
    );
};

export default PetParentProfile;
